

























import { Component, Prop, Vue } from 'vue-property-decorator';
import SingleFileHolder from "@/components/new_style_components/SingleFileHolder.vue";
import PortalTextarea from "@/components/new_style_components/PortalTextarea.vue";
import AddPRILAdditionalFilePayload from "@/dto/request/pril/AddPRILAdditionalFilePayload";
import { ifValid, processError } from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import Notifications from "@/state/Notifications";
import PRILService from "@/services/request/PRILService";

@Component({
  components: {
    SingleFileHolder,
    PortalTextarea
  }
})
export default class AddPRILAdditionalFileModal extends Vue {
  private additionalFilePayload: AddPRILAdditionalFilePayload = new AddPRILAdditionalFilePayload();

  @Prop()
  private prilId!: number;

  @Prop()
  private onSuccess!: () => void;

  private closeModal(): void {
    this.$modal.hideAll();
  }

  private save(): void {
    ifValid(this, () => {
      Application.startLoading();
      PRILService.addAdditionalFile(this.prilId, this.additionalFilePayload).then(
        () => {
          Application.stopLoading();
          this.$modal.hideAll();
          Notifications.success("The additional file has been successfully added!");
          this.onSuccess();
        },
        err => processError(err, this)
      );
    });
  }
}
